// -----------------------------------------------------------------------------
// Script for filter posts
// -----------------------------------------------------------------------------

function filterPosts() {
  var regions = [];
  var activities = [];
  var allRegions = jQuery.makeArray($('.filter-post__list--region input').map(function() {
    return this.value;
  }));
  var allActivities = jQuery.makeArray($('.filter-post__list--activity input').map(function() {
    return this.value;
  }));

  // -------------------------- MAP ----------------------------------
  $(".region-map__link").on("click", function (e) {
    regions = [];
    e.preventDefault();
    var name = $(this).attr("id");
    var region_id = $(this).attr("region_id");
    localStorage.setItem("regionId", region_id);
    regions.push(name);
    var url = window.location.href;
    var url_splitted = url.split("/");
    var lastPartURL = url_splitted[url_splitted.length - 2];

    if ( (lastPartURL !== "offers" && lastPartURL !== "#all-offers") 
        && (lastPartURL !== "oferta" && lastPartURL !== "#all-offers") 
        && (lastPartURL !== "offre" && lastPartURL !== "#all-offers")
        && (lastPartURL !== "angebot" && lastPartURL !== "#all-offers") ) {

          localStorage.setItem("region", regions);
          localStorage.removeItem("activity");
          window.location.href = cookies_data.home_url + "/" + cookies_data.offers;

          return;
    }
    
    $(".filter-post__list--region .filter-post__label--active").removeClass(
      "filter-post__label--active"
    );
    $(".filter-post__placeholder--region").addClass("filled");
    $(".filter-post__clearRegion").show();
    $("input[name='" + name + "']")
      .parent()
      .addClass("filter-post__label--active");
    $(".filter-post__placeholder--region").html(name);
    $.ajax({
      type: "post",
      url: $(this).attr("action"),
      data: { action: "region_update", region_id: region_id },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#offer-content").html(data);
        $("#searchLoader").hide();
        $(".region-map__link.region-map__link--active").removeClass(
          "region-map__link--active"
        );
        $(".region-map__link[region_id=" + region_id + "]").addClass(
          "region-map__link--active"
        );
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });

    $.ajax({
      url: $(this).attr("action"),
      type: "post",
      data: { action: "myfilter", regions: regions, activities: activities },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#response").html(data);
        $("#searchLoader").hide();
        imgToSvg();
        showResetBtn();
        localStorage.removeItem("regionId");
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });
  });

  var filter = $("#filter");
  // -------------------------- REGION ----------------------------------
  $(".filter-post__placeholder--region").on("click", function (e) {
    e.preventDefault();
    $(".filter-post__list--region").slideToggle("slow");
  });

  $(".filter-post__list--region .filter-post__label").on(
    "mousedown",
    function () {
      var region = $("input", this).attr("value");
      var reg_id = $("input", this).attr("data-id");

      if (regions.includes(region)) {
        if (region == 'all') {
          regions = [];
          $(".filter-post__list--region").find(".filter-post__label").removeClass("filter-post__label--active");
          $(".filter-post__placeholder--region").html(cookies_data.selectRegion);
          $(".filter-post__clearRegion").hide();
          $(".filter-post__placeholder--region").removeClass("filled");
        }
        else {
        var index = regions.indexOf(region);
        regions.splice(index, 1);
        if ( regions.includes('all') ) {
          $(".filter-post__label.all-regions").removeClass("filter-post__label--active");
          regions.splice(regions.indexOf('all'), 1);
        }
        if (regions.length == 0) {
          $(".filter-post__placeholder--region").html(cookies_data.selectRegion);
          $(".filter-post__clearRegion").hide();
          $(".filter-post__placeholder--region").removeClass("filled");
        } else if (regions.length == 1) {
          $(".filter-post__placeholder--region").html(regions);
          $(".filter-post__clearRegion").show();
          $(".filter-post__placeholder--region").addClass("filled");
        } else {
          $(".filter-post__placeholder--region").html(
            regions.length + " " + cookies_data.regions
          );
          $(".filter-post__clearRegion").show();
          $(".filter-post__placeholder--region").addClass("filled");
          $(".filter-post__label .all-regions").removeClass("filter-post__label--active");
        }
      }
      } else {
        if (region == "all") {
          allRegions = jQuery.makeArray($('.filter-post__list--region input').map(function() {
            return this.value;
          }));
          regions = allRegions;
          
          $(".filter-post__list--region .filter-post__label--active").removeClass("filter-post__label--active");
          $(".filter-post__list--region").find(".filter-post__label").addClass("filter-post__label--active");
          $(".filter-post__placeholder--region").html(cookies_data.allRegions);
          $(".filter-post__clearRegion").show();
          $(".filter-post__placeholder--region").addClass("filled");
        } else {
          if (regions.includes("all")) {
            regions = [];
            regions.push(region);
            $(".filter-post__placeholder--region").html(region);
            $(".filter-post__clearRegion").hide();
            $(".filter-post__placeholder--region").removeClass("filled");
          } else {
            regions.push(region);
            if (regions.length == 0) {
              $(".filter-post__placeholder--region").html(cookies_data.selectRegion);
              $(".filter-post__clearRegion").hide();
              $(".filter-post__placeholder--region").removeClass("filled");
            } else if (regions.length == 1) {
              $(".filter-post__placeholder--region").html(regions);
              $(".filter-post__clearRegion").show();
              $(".filter-post__placeholder--region").addClass("filled");
            } else {
              $(".filter-post__placeholder--region").html(
                regions.length + " " + cookies_data.regions
              );
              $(".filter-post__clearRegion").show();
              $(".filter-post__placeholder--region").addClass("filled");
            }
          }
        }
      }

      if ( region !== 'all' ) {
        if ( regions.includes('all') ) {
          $(".filter-post__label .all-regions").toggleClass("filter-post__label--active");
        }
        $(this).toggleClass("filter-post__label--active");
      }

      // $(".filter-post__list--region").slideToggle("slow");


      $.ajax({
        url: filter.attr("action"),
        type: filter.attr("method"),
        data: { action: "myfilter", regions: regions, activities: activities },
        beforeSend: function () {
          $("#searchLoader").show();
        },
        success: function (data) {
          $("#response").html(data);
          $("#searchLoader").hide();
          imgToSvg();
          showResetBtn();
        },
        error: function (err) {
          console.log("Error: " + err);
        },
      });

    }
  );

  // -------------------------- ACTIVITY ----------------------------------
  $(".filter-post__placeholder--activity").on("click", function (e) {
    e.preventDefault();
    $(".filter-post__list--activity").slideToggle("slow");
  });

  $(".filter-post__list--activity .filter-post__label").on(
    "mousedown",
    function () {
      var activity = $("input", this).attr("value");
      if (activities.includes(activity)) {
        if (activity == 'all') {
          activities = [];
          $(".filter-post__list--activity").find(".filter-post__label").removeClass("filter-post__label--active");
          $(".filter-post__placeholder--activity").html(cookies_data.selectActivity);
          $(".filter-post__clearActivity").hide();
          $(".filter-post__placeholder--activity").removeClass("filled");
        }
        else {
        var index = activities.indexOf(activity);
        activities.splice(index, 1);
        if ( activities.includes('all') ) {
          $(".filter-post__label.all-activities").removeClass("filter-post__label--active");
          activities.splice(activities.indexOf('all'), 1);
        }
        if (activities.length == 0) {
          $(".filter-post__placeholder--activity").html(cookies_data.selectActivity);
          $(".filter-post__clearActivity").hide();
          $(".filter-post__placeholder--activity").removeClass("filled");
        } else if (activities.length == 1) {
          $(".filter-post__placeholder--activity").html(activities);
          $(".filter-post__clearActivity").show();
          $(".filter-post__placeholder--activity").addClass("filled");
        } else {
          $(".filter-post__placeholder--activity").html(
            activities.length + " " + cookies_data.activities
          );
          $(".filter-post__clearActivity").show();
          $(".filter-post__placeholder--activity").addClass("filled");
        }
      }
      } else {
        if (activity == "all") {
          var allActivities = jQuery.makeArray($('.filter-post__list--activity input').map(function() {
            return this.value;
          }));
          activities = allActivities;

          $(".filter-post__list--activity .filter-post__label--active").removeClass("filter-post__label--active");
          $(".filter-post__list--activity").find(".filter-post__label").addClass("filter-post__label--active");
          $(".filter-post__placeholder--activity").html(cookies_data.allActivities);
          $(".filter-post__clearActivity").show();
          $(".filter-post__placeholder--activity").addClass("filled");
        } else {
          if (activities.includes("all")) {
            $(".filter-post__list--activity .filter-post__label--active").removeClass("filter-post__label--active");
            activities = [];
            activities.push(activity);
            $(".filter-post__placeholder--activity").html(activities);
            $(".filter-post__clearActivity").hide();
            $(".filter-post__placeholder--activity").removeClass("filled");
          } else {
            activities.push(activity);
            if (activities.length == 0) {
              $(".filter-post__placeholder--activity").html(cookies_data.selectActivity);
              $(".filter-post__clearActivity").hide();
              $(".filter-post__placeholder--activity").removeClass("filled");
            } else if (activities.length == 1) {
              $(".filter-post__placeholder--activity").html(activities);
              $(".filter-post__clearActivity").show();
              $(".filter-post__placeholder--activity").addClass("filled");
            } else {
              $(".filter-post__placeholder--activity").html(
                activities.length + " " + cookies_data.activities
              );
              $(".filter-post__clearActivity").show();
              $(".filter-post__placeholder--activity").addClass("filled");
            }
          }
        }
      }
      if ( activity !== 'all' ) {
        if ( activities.includes('all') ) {
          $(".filter-post__label .all-activities").toggleClass("filter-post__label--active");
        }
        $(this).toggleClass("filter-post__label--active");
      }

      // $(".filter-post__list--activity").slideToggle("slow");

      // $(".filter-post__clearActivity").show();


      $.ajax({
        url: filter.attr("action"),
        type: filter.attr("method"),
        data: { action: "myfilter", activities: activities, regions: regions },
        beforeSend: function () {
          $("#searchLoader").show();
        },
        success: function (data) {
          $("#response").html(data);
          $("#searchLoader").hide();
          imgToSvg();
          showResetBtn();
        },
        error: function (err) {
          console.log("Error: " + err);
        },
      });
    }
  );

  // -------------------------- ACTIVITY ICONS ----------------------------------
  $("body").on(
    "click",
    ".offer-card__activities-icon-link, .single-offer__activity, .offer-card__activity",
    function (e) {
      e.preventDefault();
      var iconName = $(this).attr("title");
      activities = [];
      activities.push(iconName);
      var url = window.location.href;
      var url_splitted = url.split("/");
      var lastPartURL = url_splitted[url_splitted.length - 2];
      if (lastPartURL !== "offers" && lastPartURL !== "#all-offers" && lastPartURL !== 'oferta' && lastPartURL !== 'offre' && lastPartURL !== 'angebot') {
        localStorage.removeItem("region");
        localStorage.setItem("activity", activities);
        window.location.href =
          cookies_data.home_url + "/" + cookies_data.offers + "#all-offers/";
      }
      $(".filter-post__placeholder--activity").html(iconName);
      $(".filter-post__list--activity .filter-post__label--active").removeClass(
        "filter-post__label--active"
      );
      $(".filter-post__placeholder--activity").addClass("filled");
      $(".filter-post__clearActivity").show();
      $("input[name='" + iconName + "']")
        .parent()
        .addClass("filter-post__label--active");
      $.ajax({
        url: filter.attr("action"),
        type: filter.attr("method"),
        data: { action: "myfilter", activities: activities, regions: regions },
        beforeSend: function () {
          $("#searchLoader").show();
        },
        success: function (data) {
          $("#response").html(data);
          $("#searchLoader").hide();
          imgToSvg();
          showResetBtn();
        },
        error: function (err) {
          console.log("Error: " + err);
        },
      });
    }
  );

  // --------------- WHEN ENTER FROM ANOTHER PAGE -----------------
  if ( (window.location.href.indexOf("offers") > -1) || (window.location.href.indexOf("oferta") > -1) || (window.location.href.indexOf("offre") > -1) || (window.location.href.indexOf("angebot") > -1) ) {
    if (localStorage.getItem("activity")) {
      activities.push(localStorage.getItem("activity"));
      $(".filter-post__placeholder--activity").html(activities);
      $(".filter-post__placeholder--activity").addClass("filled");
      $(".filter-post__clearActivity").show();
    }
    if (localStorage.getItem("region")) {
      regions.push(localStorage.getItem("region"));
      $(".filter-post__placeholder--region").html(regions);
      $(".filter-post__placeholder--region").addClass("filled");
      $(".filter-post__clearRegion").show();
      console.log(localStorage.getItem('regionId'));
    }
    $("input[name='" + localStorage.getItem("activity") + "']")
      .parent()
      .addClass("filter-post__label--active");
    $("input[name='" + localStorage.getItem("region") + "']")
      .parent()
      .addClass("filter-post__label--active");

    if (localStorage.getItem("regionId")) {
      $.ajax({
        type: "post",
        url: filter.attr("action"),
        data: {
          action: "region_update",
          region_id: localStorage.getItem("regionId"),
        },
        beforeSend: function () {
          $("#searchLoader").show();
        },
        success: function (data) {
          $("#offer-content").html(data);
          $("#searchLoader").hide();
          $(
            ".region-map__link[region_id=" +
              localStorage.getItem("regionId") +
              "]"
          ).addClass("region-map__link--active");
          localStorage.removeItem("regionId");
        },
        error: function (err) {
          console.log("Error: " + err);
        },
      });
    }

    if (localStorage.getItem("activity") || localStorage.getItem("region")) {
      $.ajax({
        url: filter.attr("action"),
        type: filter.attr("method"),
        data: { action: "myfilter", activities: activities, regions: regions },
        beforeSend: function () {
          $("#searchLoader").show();
        },
        success: function (data) {
          $("#response").html(data);
          $("#searchLoader").hide();
          imgToSvg();
          showResetBtn();
          localStorage.removeItem("activity");
          localStorage.removeItem("region");
        },
        error: function (err) {
          console.log("Error: " + err);
        },
      });
    }
  }

  // -------------------------- BUTTONS ------------------------------------------
  $("#filter-backBtn").on("click", function (e) {
    e.preventDefault();
    $("html, body").animate(
      {
        scrollTop: $("#offersMap").offset().top - 60,
      },
      1000
    );
  });

  $("#filter-resetBtn").on("click", function (e) {
    e.preventDefault();
    $(".filter-post__label--active").removeClass("filter-post__label--active");
    $(".filter-post__placeholder--activity").html(cookies_data.selectActivity);
    $(".filter-post__placeholder--region").html(cookies_data.selectRegion);

    $(".filter-post__placeholder--region").removeClass("filled");
    $(".filter-post__clearRegion").hide();

    $(".filter-post__placeholder--activity").removeClass("filled");
    $(".filter-post__clearActivity").hide();
    regions = [];
    activities = [];
    $.ajax({
      url: filter.attr("action"),
      type: filter.attr("method"),
      data: { action: "myfilter", activities: activities, regions: regions },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#response").html(data);
        $("#searchLoader").hide();
        imgToSvg();
        showResetBtn();
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });
  });

  // ------------ CLEAR REGIONS -------------------------------
  $(".filter-post__clearRegion").on("click", function (e) {
    e.preventDefault();
    $(".filter-post__list--region .filter-post__label--active").removeClass(
      "filter-post__label--active"
    );
    $(".filter-post__placeholder--region").html(cookies_data.selectRegion);
    $(".filter-post__placeholder--region").removeClass("filled");
    $(".filter-post__clearRegion").hide();
    regions = [];
    $.ajax({
      url: filter.attr("action"),
      type: filter.attr("method"),
      data: { action: "myfilter", activities: activities, regions: regions },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#response").html(data);
        $("#searchLoader").hide();
        imgToSvg();
        showResetBtn();
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });
  });

  // ------------ CLEAR ACTIVITIES -------------------------------
  $(".filter-post__clearActivity").on("click", function (e) {
    e.preventDefault();
    $(".filter-post__list--activity .filter-post__label--active").removeClass(
      "filter-post__label--active"
    );
    $(".filter-post__placeholder--activity").html(cookies_data.selectActivity);
    $(".filter-post__placeholder--activity").removeClass("filled");
    $(".filter-post__clearActivity").hide();
    activities = [];
    $.ajax({
      url: filter.attr("action"),
      type: filter.attr("method"),
      data: { action: "myfilter", activities: activities, regions: regions },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#response").html(data);
        $("#searchLoader").hide();
        imgToSvg();
        showResetBtn();
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });
  });

  //--------------------- MENU ACTIVITIES -------------------------------
  $("body").on("click", ".menu-activities__cat-link", function (e) {
    e.preventDefault();
    var itemName = $(this).attr("title");
    localStorage.removeItem("region");
    localStorage.setItem("activity", itemName);
    var url = window.location.href;
    var url_splitted = url.split("/");
    var lastPartURL = url_splitted[url_splitted.length - 2];

    if (lastPartURL !== "offers" && lastPartURL !== "#all-offers") {
      window.location.href =
        cookies_data.home_url + "/" + cookies_data.offers + "#all-offers/";
    }
    $(".filter-post__placeholder--activity").html(itemName);
    $(".filter-post__list--activity .filter-post__label--active").removeClass(
      "filter-post__label--active"
    );
    $(".filter-post__placeholder--activity").addClass("filled");
    $(".filter-post__clearActivity").show();
    $("input[name='" + itemName + "']")
      .parent()
      .addClass("filter-post__label--active");
    activities = [];
    activities.push(itemName);
    $.ajax({
      url: filter.attr("action"),
      type: filter.attr("method"),
      data: { action: "myfilter", activities: activities, regions: regions },
      beforeSend: function () {
        $("#searchLoader").show();
      },
      success: function (data) {
        $("#response").html(data);
        $("#searchLoader").hide();
        imgToSvg();
      },
      error: function (err) {
        console.log("Error: " + err);
      },
    });
    $("html, body").animate(
      {
        scrollTop: $("#all-offers").offset().top,
      },
      1000
    );
  });

  function imgToSvg() {
    $("img.svg").each(function () {
      var $img = $(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");

      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find("svg");
          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }
          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");
          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });
  }

  // Close filters menus when click somewhere outside
  $(document).on("mousedown", ".page-template-offers", function (event) {
    if (
      !$(event.target).closest(".filter-post").length &&
      !$(event.target).closest(".filter-post__item").length
    ) {
      $(".filter-post__list--activity").slideUp("slow");
      $(".filter-post__list--region").slideUp("slow");
    }
  });

  
  function showResetBtn() {
    if (activities.length > 0 && regions.length > 0) {
      $("#filter-resetBtn").show();
    } else {
      $("#filter-resetBtn").hide();
    }
  }

  // Scroll to filter results when entering from other page by clicking to activity icon
  if ($(".page-template-offers").length > 0) {
    var url = window.location.href;
    var url_splitted = url.split("/");
    var lastPartURL = url_splitted[url_splitted.length - 2];

    if (lastPartURL === "#all-offers") {
      $("html, body").animate(
        {
          scrollTop: $("#all-offers").offset().top,
        },
        1000
      );
    }
  }
}
